export function calcPointsEarned(score, newStreak, prevStreak, newlyMastered) {
  let pts = 10;
  if (score >= 80 && score < 90) pts += 5;
  else if (score >= 90 && score < 100) pts += 10;
  else if (score === 100) pts += 20;
  if (newStreak > prevStreak) pts += 5;
  pts += newlyMastered * 3;
  return pts;
}

export function calcMeaningPoints(score) {
  let pts = 8;
  if (score >= 80 && score < 90) pts += 4;
  else if (score >= 90 && score < 100) pts += 8;
  else if (score === 100) pts += 15;
  return pts;
}

export function calcSynonymPoints(score) {
  let pts = 8;
  if (score >= 80 && score < 90) pts += 4;
  else if (score >= 90 && score < 100) pts += 8;
  else if (score === 100) pts += 15;
  return pts;
}

export function calcAntonymPoints(score) { return calcSynonymPoints(score); }
